module.exports = {
    ENVIRONMENT: 'client',
    BACKEND_URL: '',
    PUBLIC_URL: "https://www.bobtv.fr",
    UPLOAD_URL: 'https://upload.bobtv.fr',
    BOBSTORE_URL: 'http://bobstore.fr',
    BACKEND_URL_PREFIX: '/_backend',
    WSS_URL: '/instanoti/websocket',
    HITAGI_PM_URL: '/hitagi/im/websocket',
    MESSAGES_BACKEND: 'hitagi', // backend | hitagi

    BACKEND_AUTH_USER: '',
    BACKEND_AUTH_PASSWORD: '',

    REDUX_LOGGER_OPTS: {
        duration: true,
        diff: true
    },

    USE_AUTH_TOKEN: false,

    FIREBASE_CREDENTIALS: {
        apiKey: "AIzaSyBmoA2EawMFy5Wmzg2UIPBvggtGdKC_Bbw",
        authDomain: "bobtv-push.firebaseapp.com",
        databaseURL: "https://bobtv-push.firebaseio.com",
        projectId: "bobtv-push",
        storageBucket: "bobtv-push.appspot.com",
        messagingSenderId: "952339726096",
        appId: "1:952339726096:web:d238e2f9ff95f527cbaf95",
        measurementId: "G-8Z18BJDZ05"
    }
};



// WEBPACK FOOTER //
// ./app-config.default.js